<template src="./page-not-found.html"></template>
<script>
export default {
  name: "app-page-not-found"
};
</script>

<style src="./page-not-found.css"></style>
